import PageHeader from "./PageHeader";

export default function RefundPolicy() {
  return (
    <>
      <PageHeader seoKey={"refundPolicy"} />
      <section className="container py-5">
        <div className="row g-4">
          <div className="col-lg-12">
            <div className="card shadow-sm border-0 h-100">
              <div className="card-body p-4">
                <h5 className="fw-bold mb-4">Refund Policy</h5>

                <ol className="mb-4">
                  <li>
                    You can initiate a request for refund by WhatsApp on{" "}
                    <strong>0311-7266767</strong> or call{" "}
                    <strong>0311-7266767</strong> or email{" "}
                    <strong>auraskinpremium@gmail.com</strong>.
                  </li>
                  <li>
                    You can avail the refund within <strong>7 days</strong> of
                    parcel delivery.
                  </li>
                  <li>
                    <strong>Important note:</strong> Aura Skin Premium will not
                    entertain the refund request if returned product is not
                    received by us within 7 days.
                  </li>
                  <li>
                    After receiving your parcel, our quality control team will
                    thoroughly inspect your parcel.
                  </li>
                  <li>
                    If the product is used and tag is missing, Aura Skin Premium
                    will not entertain refund requests.
                  </li>
                </ol>

                <div className="mt-3">
                  <p className="mb-1">
                    <strong>Email:</strong> auraskinpremium@gmail.com
                  </p>
                  <p className="mb-1">
                    <strong>Call:</strong> 0311-7266767
                  </p>
                  <p className="mb-1">
                    <strong>WhatsApp:</strong> 0311-7266767
                  </p>
                  <p className="mb-0">
                    <strong>Facebook:</strong> Aura Skin Premium
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
